<template>
  <div>
    <HeroSmall />
    <b-container class="mt-5 mb-5">
      <h1 class="display-1">{{ this.$route.params.country }}</h1>
    </b-container>
    <Blogs :tag="this.$route.params.country" />
  </div>
</template>

<script>
import HeroSmall from '@/components/ui/HeroSmall.vue'
import Blogs from '@/components/ui/Blogs.vue'

export default {
  name: 'Country',
  components: {
    HeroSmall,
    Blogs,
  }
}
</script>

<style scoped>

</style>